<template>
    <th
    :class="['line-item-100', 'text-center', {'boq-col-markup': item.value === 14}]"
    v-for="(item, key) in ColumnNeeded"
    valign="middle"
    :key="key"
    v-html="TranslatedColumnName(item)"
    >
    </th>
</template>

<script>
import {BoQColumnList} from '@/helpers/utilities.js'

export default {
    name : 'BoqLineItemRowThead',
    props : ['selectedColumns','ReformatNumber'],
    computed: {
        ColumnNeeded(){
            return BoQColumnList.filter(u=>this.selectedColumns.indexOf(u.value) > -1)
        }
    },
    methods: {
        TranslatedColumnName(item){
            return this.$t(item.translationKey || item.name)
                .replace('（', '<br/>（')
                .replace('(', '<br/>(')
        }
    }
}
</script>
